import { PLATFORM_ROLES } from './platformSchema';
import { getLegacyOrganizationMemberships, resolveOrganizationMemberships } from './organizationData';

export function resolvePlatformRole(userData = {}) {
  if (userData?.platformRole) return userData.platformRole;
  if (userData?.role === 'admin') return PLATFORM_ROLES.PLATFORM_SUPER_ADMIN;
  if (userData?.role === 'organization') return PLATFORM_ROLES.ORGANIZATION;
  if (userData?.role === 'instructor') return PLATFORM_ROLES.INSTRUCTOR;
  return PLATFORM_ROLES.STUDENT;
}

export function getOrganizationMemberships(userData = {}, options = {}) {
  return resolveOrganizationMemberships(
    userData,
    options.organizationMembers || [],
    options.organizationsById || {}
  ) || [];
}

export function getCurrentOrganizationContext(userData = {}, preferredOrganizationId = '', options = {}) {
  const memberships = getOrganizationMemberships(userData, options);
  if (memberships.length === 0) return null;

  return (
    memberships.find((membership) => membership.organizationId === preferredOrganizationId) ||
    memberships[0]
  );
}

export { getLegacyOrganizationMemberships };
